import { Observable } from 'rxjs';
import {
  InitVerificationRequest,
  CompleteVerificationRequest,
  IDeleteGmbListingPayload,
  UpdateBusinessData,
  BaseServiceResponse,
  LookUpAdminRequest,
  ISetOwnershipRequest,
} from '../models/api-models';

import { FetchVerificationResponse, FetchVerificationRequest } from '../models/claiming.models';

export abstract class IDashBoardService {
  public abstract fetchVerificationOptions(id: string, obj: FetchVerificationRequest): Observable<FetchVerificationResponse>;

  public abstract initializeVerification(id: number, req: InitVerificationRequest): Observable<any>;

  public abstract completeVerification(id: number, req: CompleteVerificationRequest): Observable<any>;

  public abstract deleteBusinessData(payload: IDeleteGmbListingPayload): Observable<any>;

  public abstract activateBusiness(payload: UpdateBusinessData): Observable<BaseServiceResponse<any>>;

  public abstract updateBusinessData(payload: UpdateBusinessData): Observable<BaseServiceResponse<any>>;

  public abstract getClaimingStatus(establishmendId: LookUpAdminRequest): Observable<any>;

  public abstract setOwnershipRequested(request: ISetOwnershipRequest): Observable<any>;
}
